import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'
import {useIntl} from 'react-intl'
import {useAuth} from '../../../../app/modules/auth'

/*RECAP
TREND
SINGLE
CATEGORY
SYSTEM
*/
export function MenuInner() {
  const ROLE_ADMIN = parseInt(process.env.REACT_APP_ROLE_ADMIN + '')
  const ROLE_MANAGER = parseInt(process.env.REACT_APP_ROLE_MANAGER + '')
  const ROLE_EMPLOYEE = parseInt(process.env.REACT_APP_ROLE_EMPLOYEE + '')
  console.log('ROLE_MANAGER', ROLE_MANAGER)
  const intl = useIntl()
  const {checkAuthorization} = useAuth()
  const {currentUser, logout} = useAuth()
  return (
    <>
      <MenuItem
        fontIcon='fa-solid fa-house text-white-shrink'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        to='/dashboard'
      />

      {checkAuthorization([ROLE_MANAGER, ROLE_EMPLOYEE]) && (
        <MenuInnerWithSub
          title={intl.formatMessage({id: 'MENU.DIAGNOSTICS'})}
          to='/diagnostic'
          fontIcon='fa-solid fa-toolbox text-white-shrink'
          menuPlacement='bottom-start'
          menuTrigger='hover'
        >
          
          
          <MenuItem
            title={intl.formatMessage({id: 'MENU.DIAGNOSTICS.SINGLE'})}
            to='/diagnostic/single'
            fontIcon='fa-solid fa-chart-line'
          />
          
          <MenuItem
            title={intl.formatMessage({id: 'MENU.DIAGNOSTICS.SYSTEM'})}
            to='/diagnostic/system'
            fontIcon='fa-solid fa-chart-line'
          />

<MenuItem
            title={intl.formatMessage({id: 'MENU.DIAGNOSTICS.DIAGNOSTIC_EVENTS_OCCURRENCIES'})}
            to='/diagnostic/events-occurrencies'
            fontIcon='fa-solid fa-chart-simple'
          />
<MenuItem
            title={intl.formatMessage({id: 'MENU.DIAGNOSTICS.DIAGNOSTIC_EVENTS_DURATIOIN'})}
            to='/diagnostic/events-duration'
            fontIcon='fa-solid fa-chart-simple'
          />


        </MenuInnerWithSub>
      )}
      {checkAuthorization([ROLE_MANAGER, ROLE_EMPLOYEE]) && (
        <MenuInnerWithSub
          title={intl.formatMessage({id: 'MENU.REPORT_DEVICE'})}
          to='/reports'
          fontIcon='fa-solid fa-chart-column text-white-shrink'
          menuPlacement='bottom-start'
          menuTrigger='hover'
        >
          <MenuItem
            title={intl.formatMessage({id: 'MENU.DIAGNOSTICS.RECAP'})}
            to='/reports/recap'
            fontIcon='fa-solid fa-chart-pie'
          />
          <MenuItem
            title={intl.formatMessage({id: 'MENU.DIAGNOSTICS.TREND'})}
            to='/reports/trend'
            fontIcon='fa-solid fa-chart-simple'
          />
          <MenuItem
            title={intl.formatMessage({id: 'MENU.DIAGNOSTICS.CATEGORY'})}
            to='/reports/category'
            fontIcon='fa-solid fa-chart-line'
          />
          <MenuItem
            title={intl.formatMessage({id: 'MENU.REPORT_DEVICE.EVENTS'})}
            to='/reports/events'
            fontIcon='fa-solid fa-chart-line'
          />
          <MenuItem
            title={intl.formatMessage({id: 'MENU.REPORT_DEVICE.COMPARISON'})}
            to='/reports/comparison'
            fontIcon='fa-solid fa-chart-simple'
          />

          <MenuItem
            title={intl.formatMessage({id: 'MENU.REPORT_DEVICE.TREND'})}
            to='/reports/device-trend'
            fontIcon='fa-solid fa-chart-simple'
          />
           <MenuItem
            title={intl.formatMessage({id: 'MENU.REPORT_DEVICE.SARCH_KEYWORD'})}
            to='/reports/keywords'
            fontIcon='fa-solid fa-chart-simple'
          />

        </MenuInnerWithSub>
      )}

      {checkAuthorization([ROLE_MANAGER, ROLE_EMPLOYEE]) && (
        <MenuInnerWithSub
          title={intl.formatMessage({id: 'MENU.OPERATION_RANKING'})}
          to='/operation-ranking'
          fontIcon='fa-solid fa-users-gear text-white-shrink'
          menuPlacement='bottom-start'
          menuTrigger='hover'
        >
          <MenuItem
            title={intl.formatMessage({id: 'MENU.OPERATION_RANKING.USER_MANAGED_EVENTS'})}
            to='/operation-ranking/user-managed-events'
            fontIcon='fa-solid fa-chart-simple'
          />

          <MenuItem
            title={intl.formatMessage({id: 'MENU.OPERATION_RANKING.EVENTS_NEVER_CLOSED'})}
            to='/operation-ranking/events-never-closed'
            fontIcon='fa-solid fa-chart-simple'
          />

        {/*   <MenuItem
            title={intl.formatMessage({id: 'MENU.OPERATION_RANKING.EVENTS_CLOSING_TIME'})}
            to='/operation-ranking/events-closing-time'
            fontIcon='fa-solid fa-chart-simple'
          /> */}
        </MenuInnerWithSub>
      )}

      {checkAuthorization([ROLE_MANAGER, ROLE_EMPLOYEE]) && (
        <MenuInnerWithSub
          title={intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS'})}
          to='/system-settings'
          fontIcon='fa-solid fa-gear text-white-shrink'
          menuPlacement='bottom-start'
          menuTrigger='hover'
        >
          <MenuItem
            title={intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION'})}
            to='/system-settings/event-subscription'
            fontIcon='fa-solid fa-bell'
          />

          

          <MenuItem
            title={intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS.SERVERS'})}
            to='/system-settings/servers'
            fontIcon='fa-solid fa-server'
          />
          <MenuItem
            title={intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS.SERVER_GROUPS'})}
            to='/system-settings/server-groups'
            fontIcon='fa-solid fa-layer-group'
          />
          <MenuItem
            title={intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS.STATISTICS_GENERATION_LOGS'})}
            to='/system-settings/datamart-logs'
            fontIcon='fa-solid fa-list-ul'
          />
        </MenuInnerWithSub>
      )}

      <div className='menu-item me-lg-1'>
        <a className='menu-link' onClick={logout}>
          <span className='menu-title'>
            <i className='fa-solid fa-right-from-bracket fs-3 text-white-shrink'></i> Logout
          </span>
        </a>
      </div>
    </>
  )

  /*
SYSTEM_SETTINGS
EVENTS_SUBSCRIPTION


*/
}
